<template>
  <el-dialog
    :visible.sync="isOpen"
    :show-close="false"
    class="egl-dialog-elm channel-dialog"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $emit('update:isOpen', false)"
    :append-to-body="true"
  >
    <slot></slot>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ""
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
}
</script>
<style></style>